import { styled } from '@mui/material/styles';
import { Box, Card, Stack, Typography, ButtonBase } from '@mui/material';

export const DashboardContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(6, 6, 8),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(6),
  minHeight: '100vh',
  background: theme.palette.background.default,
}));

export const DashboardSection = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(3),
}));

export const DashboardCard = styled(Card)(({ theme }) => ({
  background: `linear-gradient(145deg, rgba(255, 255, 255, 0.04), rgba(5, 18, 33, 0.35))`,
  border: '1px solid rgba(255, 255, 255, 0.05)',
  boxShadow: '0 18px 40px rgba(3, 198, 252, 0.08)',
  borderRadius: 6,
}));

export const StatTileContainer = styled(ButtonBase)(({ theme }) => ({
  width: '100%',
  justifyContent: 'flex-start',
  textAlign: 'left',
  borderRadius: 6,
  padding: theme.spacing(3),
  background: `linear-gradient(160deg, rgba(3, 198, 252, 0.12), rgba(255, 255, 255, 0.02))`,
  border: '1px solid rgba(3, 198, 252, 0.18)',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  boxShadow: '0 18px 40px rgba(3, 198, 252, 0.06)',
  '&:hover': {
    transform: 'translateY(-6px)',
    boxShadow: '0 28px 70px rgba(3, 198, 252, 0.18)',
    borderColor: 'rgba(3, 198, 252, 0.35)',
    background: `linear-gradient(160deg, rgba(3, 198, 252, 0.18), rgba(255, 255, 255, 0.04))`,
  },
}));

export const StatTileTitle = styled(Typography)(({ theme }) => ({
  fontSize: '0.95rem',
  fontWeight: 600,
  color: 'rgba(242, 244, 248, 0.75)',
  marginBottom: theme.spacing(1),
}));

export const StatTileValue = styled(Typography)(({ theme }) => ({
  fontSize: '1.95rem',
  fontWeight: 700,
  letterSpacing: '-0.02em',
}));

export const StatTileMeta = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'colorVariant',
})(({ theme, colorVariant }) => ({
  fontSize: '0.85rem',
  fontWeight: 500,
  color:
    colorVariant === 'up'
      ? theme.palette.success.main
      : colorVariant === 'down'
      ? theme.palette.error.main
      : 'rgba(242, 244, 248, 0.65)',
}));
